// src/pages/seller/ShippingPage.jsx
import React, { useState } from 'react';

const ShippingPage = () => {
  const [trackingInfo, setTrackingInfo] = useState({
    carrier: '',
    trackingNumber: '',
    invoiceFile: null,
    packingListFile: null
  });

  const handleFileUpload = (e, field) => {
    setTrackingInfo(prev => ({
      ...prev,
      [field]: e.target.files[0]
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Firestore에 수출 문서 업로드 로직
    console.log('Submit shipping documents:', trackingInfo);
  };

  return (
    <div>
      <h1 className="text-2xl font-medium text-gray-900 mb-6">Logistics / Shipping</h1>
      
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* 송장 관리 */}
        <div className="border border-gray-200 rounded-lg p-6">
          <h2 className="text-lg font-medium mb-4">Shipping Documents</h2>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Carrier</label>
              <select
                value={trackingInfo.carrier}
                onChange={(e) => setTrackingInfo(prev => ({ ...prev, carrier: e.target.value }))}
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
              >
                <option value="">Select carrier</option>
                <option value="dhl">DHL</option>
                <option value="fedex">FedEx</option>
                <option value="cj">CJ대한통운</option>
              </select>
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Tracking Number</label>
              <input
                type="text"
                value={trackingInfo.trackingNumber}
                onChange={(e) => setTrackingInfo(prev => ({ ...prev, trackingNumber: e.target.value }))}
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
                placeholder="Enter tracking number"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Commercial Invoice</label>
              <input
                type="file"
                accept=".pdf,.jpg,.png"
                onChange={(e) => handleFileUpload(e, 'invoiceFile')}
                className="w-full"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Packing List</label>
              <input
                type="file"
                accept=".pdf,.jpg,.png"
                onChange={(e) => handleFileUpload(e, 'packingListFile')}
                className="w-full"
              />
            </div>
            
            <button
              type="submit"
              className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700"
            >
              Upload Documents
            </button>
          </form>
        </div>
        
        {/* 배송 상태 추적 */}
        <div className="border border-gray-200 rounded-lg p-6">
          <h2 className="text-lg font-medium mb-4">Shipment Tracking</h2>
          <div className="space-y-4">
            {[
              { id: 'SHIP-001', carrier: 'DHL', tracking: '123456789', status: 'In Transit', date: '2025-04-05' },
              { id: 'SHIP-002', carrier: 'FedEx', tracking: '987654321', status: 'Delivered', date: '2025-04-01' }
            ].map((shipment, i) => (
              <div key={i} className="p-3 border border-gray-200 rounded">
                <div className="flex justify-between">
                  <span className="font-medium">{shipment.carrier}</span>
                  <span className="text-sm text-gray-600">{shipment.date}</span>
                </div>
                <p className="text-sm mt-1">Tracking: {shipment.tracking}</p>
                <span className={`px-2 py-1 rounded-full text-xs mt-2 ${
                  shipment.status === 'Delivered' ? 'bg-green-100 text-green-800' :
                  'bg-blue-100 text-blue-800'
                }`}>
                  {shipment.status}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShippingPage;